import {useEffect} from "react";
import {ThemeContext, themes} from "../../contexts/ThemeContext";
import useThemeHandler from "../../hooks/ThemeHandler";
import {getStoredUserTheme} from "../../utils/userTheme";

export default function ThemeContextWrapper(props) {
  const {theme, setThemeStatus} = useThemeHandler(getStoredUserTheme());

  function changeTheme(theme) {
    setThemeStatus(theme);
  }

  useEffect(() => {
    switch (theme) {
      case themes.light:
        document.body.classList.add("white-content");
        break;
      case themes.dark:
      default:
        document.body.classList.remove("white-content");
        break;
    }
  }, [theme]);

  return (
    <ThemeContext.Provider value={{theme: theme, changeTheme: changeTheme}}>{props.children}</ThemeContext.Provider>
  );
}
